import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { isMobileOnly } from 'react-device-detect';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { savePDF } from '@progress/kendo-react-pdf';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import Notification from 'rc-notification';
import SmallLoader from '../../../../shared/components/SmallLoader';
import { RTLProps } from '../../../../shared/prop-types/ReducerProps';
import { getVirtualBundleSalesData, handleLoader } from '../../../../redux/actions/VirtualBundleSalesAction';
import ShowBySelectedAsins from './ShowBySelectedAsins';
import ViewSalesReportModal from '../../SalesCategoryByDay/ViewSalesReportModal';
import { setCurrencyFormat } from '../../../../utils/helpers';
import {
    tableHeaderDataVirtualBundleSales as tableHeaderData
} from '../../helper';

const VirtualBundleSales = ({ dispatch, rtl }) => { 

    const location = useLocation();

    const { virtualBundleSalesData, salesChannelFilterData, isLoading } = useSelector(
        ({ virtualBundleSalesReducer, marketPlaceReducer }) =>
        ({
            virtualBundleSalesData: virtualBundleSalesReducer.virtualBundleSalesData,
            salesChannelFilterData: marketPlaceReducer.salesChannel,
            isLoading: virtualBundleSalesReducer.isLoading
        })
    );

    const previousMonthDate = new Date();
    previousMonthDate.setMonth(previousMonthDate.getMonth() - 1)

    const [dataToShow, setDataToShow] = useState(virtualBundleSalesData?.modal?.data);
    const [isOpen, setIsOpen] = useState(false);
    const [filterData, setFilterData] = useState({});
    const [fromDate, setFromDate] = useState(previousMonthDate);
    const [toDate, setToDate] = useState(new Date());

    const handleFromDateChange = (date) => {
        setFromDate(date);
    };

    const handleToDateChange = (date) => {
        setToDate(date);
    };

    const filterBasedOnFilter = (item) => {
        const filters = Object.keys(filterData);
        let flag = true
        // eslint-disable-next-line no-restricted-syntax
        for (const i of filters) {
            const filter = filterData[i];
            const filtersArray = filter?.reduce((acc, fil) => [...acc, fil?.value], []) ?? [];
            if (filtersArray?.length && !filtersArray.includes(item?.[i]?.toLowerCase())) {
                flag = false
            }
        }

        return flag
    }

    const container = React.useRef(null);
  const exportToPDF = () => {
    // console.log('Hello')
    Notification.newInstance({}, (notification) => {
      notification.notice({
        content: 'PDF loading......',
        duration: 10,
        style: {top: 120, fontWeight: "bold"},
        maxCount: 10
      });
    });
    const dvChartF = document.getElementById('dvChartFilter');
    const dvChartV = document.getElementById('dvChartView');
    dvChartF.style.display = "none";  
    dvChartV.style.display = "none";    
    const element = container.current || document.body;
    
    savePDF(element, {
      paperSize: "auto",
      Header: "test",
      margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" },
     // margin: "2cm",
     // forcePageBreak: ".page-break",
    //   landscape: true,
    //  multiPage: true,
      fileName: `Virtual Bundle Sales Report ${new Date().getFullYear()}`,
    })
    dvChartF.style.display = "block";  
    dvChartV.style.display = "block"; 
  }

    const handleApplyDate = () => {
        const intFromDate = moment(fromDate).format('YYYYMMDD');
        const intToDate = moment(toDate).format('YYYYMMDD');
        if (intToDate > intFromDate) {
            dispatch(handleLoader(true));
            dispatch(getVirtualBundleSalesData({ fromdate: moment(fromDate).format('YYYY-MM-DD'),
            todate: moment(toDate).format('YYYY-MM-DD') }));
        }
        else {
            Notification.newInstance({}, (notification) => {
                notification.notice({
                    content: 'To Date must be greater than From Date.'
                });
            });
        }        
    }     

    const viewReportButton = () => (
        <div className="view-report">
            <button
                type="button"
                className="view-report btn btn-primary btn-sm"
                onClick={() => setIsOpen(true)}
            >
                View Report
            </button>
        </div>
    )

    useEffect(() => {
        dispatch(handleLoader(true));
        dispatch(getVirtualBundleSalesData({ fromdate: moment(fromDate).format('YYYY-MM-DD'),
        todate: moment(toDate).format('YYYY-MM-DD')}));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        setDataToShow(virtualBundleSalesData?.modal?.data);
    }, [virtualBundleSalesData]);

    useEffect(() => {
        const OptChennel = 'salesChannel';
        setFilterData({ ...filterData, [OptChennel]: salesChannelFilterData });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [salesChannelFilterData])

    const dataToShowForDatesSelected = dataToShow?.filter(item => filterBasedOnFilter(item))    

    const modalData = dataToShowForDatesSelected?.map(item => ({
        ...item,
        date: item.reportDate,
        amount: setCurrencyFormat(Number(item.amount).toFixed(2), true),
        day: Number(item.day).toFixed(0),
        soldQuantity: setCurrencyFormat(Number(item.soldQuantity).toFixed(0), false),
    }));
    return (
        <Container className="dashboard">
            <Row className="compare-months">
                <Col sm="12">
                    <Card className="pb-3">
                        <CardBody className="min-w-50 p-3">
                            <div className="card__title mb-2">
                                <h5 className="bold-text card__title-center">
                                    Virtual Bundle Sales</h5>
                            </div>
                            <Row className="justify-content-space-between align-items-center">                         
                                <Col sm="3" md="10">
                                    <Row className="align-items-center">
                                        <Col sm="3">
                                            <div className="form__form-group mb-0">
                                                <span className="form__form-group-label">Date</span>
                                                <div className="form__form-group-field">
                                                    <div className="date-picker">
                                                        <DatePicker
                                                            className="form__form-group-datepicker"
                                                            selected={moment(fromDate).toDate()}
                                                            showPreviousMonths
                                                            onChange={handleFromDateChange}
                                                            dateFormat="MM/dd/yyyy"
                                                            dropDownMode="select"
                                                            popperPlacement="center"
                                                            withPortal={isMobileOnly}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col sm="3">
                                            <div className="form__form-group mb-0">
                                                <span className="form__form-group-label">To Date</span>
                                                <div className="form__form-group-field">
                                                    <div className="date-picker">
                                                        <DatePicker
                                                            className="form__form-group-datepicker"
                                                            selected={moment(toDate).toDate()}
                                                            onChange={handleToDateChange}
                                                            dateFormat="MM/dd/yyyy"
                                                            dropDownMode="select"
                                                            popperPlacement="center"
                                                            withPortal={isMobileOnly}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col sm="6" style={{ top: '10px' }}>
                                            <button className="btn btn-sm btn-primary apply-date-button"
                                                type="button" onClick={handleApplyDate}>
                                                Apply</button>
                                                <button className="btn btn-sm btn-primary
                                             apply-date-button" type="button"
                                             title='Export to pdf' disabled={isLoading}
                                    onClick={exportToPDF}>Export PDF</button>
                                        </Col>                                        
                                    </Row>
                                </Col>                                
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <div id="divToPrint" ref={container}>
            <Row className="show-categ-day-wise-sales">
                <Col xs="12">
                    <Card className="pb-3 show-categ-daily-sales">
                        <CardBody>
                            {isLoading ? (
                                <>
                                    <div className="card__title">
                                        <h5 className="bold-text">
                                        Virtual Bundle Sales
                                            </h5>
                                    </div>
                                    <div
                                        style={{ minHeight: '200px' }}
                                        className="row align-items-center justify-content-center"
                                    >
                                        <SmallLoader loading={isLoading} />
                                    </div>
                                </>) : (
                                <ShowBySelectedAsins
                                    dir={rtl.direction}
                                    dataToShowForDatesSelected={dataToShowForDatesSelected}
                                    height={300}
                                    title='Virtual Bundle Sales'
                                    viewReportButton={viewReportButton}
                                />)}
                        </CardBody>

                    </Card>
                </Col>
            </Row>
            </div>
            <ViewSalesReportModal
                modalData={modalData}
                isOpen={isOpen}
                handleModal={setIsOpen}
                tableHeaderData={tableHeaderData}
                fileName='Virtual Bundle Sales Report'
                title='Virtual Bundle Sales Report'
            />
        </Container>
    );
};

VirtualBundleSales.propTypes = {
    dispatch: PropTypes.func.isRequired,
    rtl: RTLProps.isRequired,
};

export default connect(state => ({
    rtl: state.rtl,
}))(VirtualBundleSales);
